import { useProjectDetailsContext } from "pages/project/context/ProjectDetailsContext";
import { getProjectDetailsTabComponent } from "pages/project/details/projectDetailsTabs";

export default function ProjectDetailsTabsContent() {
  const { activeTab } = useProjectDetailsContext();
  const ActiveTabComponent = getProjectDetailsTabComponent(activeTab.id);

  return (
    <div className="p-5">
      <h3 className="text-lg font-semibold text-text-900">{activeTab.label}</h3>
      <ActiveTabComponent isTabView />
    </div>
  );
}
